import axios from "axios";
import {combineReducers} from "redux";

const USER_ACCOUNT_GET_INFO = "accountManagement/USER_ACCOUNT_GET_INFO";
const Enterprise_ACCOUNT_GET_INFO = "accountManagement/Enterprise_ACCOUNT_GET_INFO";

function content (state = {
                                          user: {
                                            accountId:"",
                                          },
                                        }
  ,action){
  switch (action.type) {
    case USER_ACCOUNT_GET_INFO:
      console.log("user: ", action.data)
      let newUser = {
        accountId: action.data.account,
        //accountId:"9b2d7dab-72a1-4549-82c0-18bb98f23606",
      };
      return {
        ...state,
        user: newUser
      };

    case Enterprise_ACCOUNT_GET_INFO:
      console.log("user: ", action.data)
      let newEnterprise = {
        accountId: action.data.account,
        //accountId:"9b2d7dab-72a1-4549-82c0-18bb98f23605",
      };
      return {
        ...state,
        user: newEnterprise
      };
    default:
      return state
  }
}

export const getUserAccount = (userId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/users?userId=" + userId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
        dispatch(getUserAccountDone(response.data))
    })
}

export const getUserAccountDone = (data) => {
  return {
    type: USER_ACCOUNT_GET_INFO,
    data: data
  }
}

export const getEnterpriseAccount = (enterpriseId) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/enterprise?id=" + enterpriseId;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      dispatch(getEnterpriseAccountDone(response.data))
    })
}

export const getEnterpriseAccountDone = (data) => {
  return {
    type: Enterprise_ACCOUNT_GET_INFO,
    data: data
  }
}

function isLoading(state=true,action){
  switch (action.type){
    case USER_ACCOUNT_GET_INFO:
      return false;
    case Enterprise_ACCOUNT_GET_INFO:
      return false;
    default:
      return state;
  }
}

const accountManagement = combineReducers({content,isLoading,}
  // headerContent,advertisements,redirectItems,
  // rapidRegs}
);
export default  accountManagement;
